'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import {
    ChakraProvider,
    Flex,
    Box,
    Heading,
    Text,
    Icons,
    Link,
    HStack,
} from '@shared/ui';
import i18n from '@shared/i18n';

export default function GlobalNotFound() {
    const pathname = usePathname();

    const isPanel = pathname.includes('/panel');

    return (
        <ChakraProvider>
            <Flex h="calc(100vh)" alignItems="center" justifyContent="center">
                <Box w="100%" maxW="600px" mx="auto" px="m" py="xl" textAlign="center">
                    <HStack mt="9px" color="neutral.100" justifyContent="center">
                        <Icons.csr.SmileyXEyes size="60px" weight="bold" />
                        <Heading
                            fontSize={{
                                base: '24px',
                                md: '30px',
                            }}
                            color="neutral.120"
                            lineHeight="1.5"
                        >
                            {i18n.gettext('找不到頁面')}
                        </Heading>
                    </HStack>
                    <Box mt="21px">
                        <Text fontSize="16px" color="neutral.080" lineHeight="1.5">
                            {i18n.gettext(
                                '此頁面網址失效導致我們找不到該頁面，請嘗試回到首頁或瀏覽其他頁面！'
                            )}
                        </Text>
                    </Box>
                    <Box mt="24px">
                        <Link href={isPanel ? '/panel' : '/'}>
                            {isPanel
                                ? i18n.gettext('回商店後台')
                                : i18n.gettext('回首頁')}
                        </Link>
                    </Box>
                </Box>
            </Flex>
        </ChakraProvider>
    );
}
